import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { VideoType } from '../types/entities';
import Expander from '@helsenorge/designsystem-react/components/Expander';
import designsystemtypography from '@helsenorge/designsystem-react/scss/typography.module.scss';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { VimeoSubtitleLanguageCodes } from './constants';
import { getResources } from './resources';
import VideoCookieBanner from './video-cookie-consent';
import { hasAcceptedVideoCookies } from '../cookie-banner/cookie';
import { useCookieConsentChange } from '../cookie-banner/events';
import PortableText from '../richtext';
import { useLanguage } from '../shared/language';
import cmsstyles from './styles.module.scss';
const VideoSpiller = props => {
    const { title, description, videoId, videoType, altText, showTextContent = false, visualInterpretation, subtitleLanguageCode = VimeoSubtitleLanguageCodes.NORWEGIAN, className, } = props;
    const { language } = useLanguage(LanguageLocales.NORWEGIAN);
    const defaultResources = getResources(language);
    const resources = { ...defaultResources, ...props.resources };
    const videospillerRef = useRef(null);
    const [acceptedVideoCookies, setAcceptedVideoCookies] = useState(false);
    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- Vi trenger denne da vi leser fra window.HN som ikke er tilgjengelig ved SSR.
        setAcceptedVideoCookies(hasAcceptedVideoCookies());
    }, []);
    useCookieConsentChange(detail => {
        setAcceptedVideoCookies(detail.options.VideoCookies);
    });
    const handleCookieConsentChange = (options) => {
        if (options.VideoCookies && videospillerRef.current) {
            videospillerRef.current.focus();
        }
    };
    const getVideoUrl = () => {
        if (videoType === VideoType.youtube) {
            return `https://www.youtube-nocookie.com/embed/${videoId}?&rel=0`;
        }
        else if (videoType === VideoType.vimeo) {
            return `https://player.vimeo.com/video/${videoId}?texttrack=${subtitleLanguageCode}`;
        }
        else if (videoType === VideoType.vimeoShowcase) {
            return `https://vimeo.com/showcase/${videoId}/embed?texttrack=${subtitleLanguageCode}`;
        }
        return '';
    };
    const getAllowAttribute = () => {
        if (videoType === VideoType.youtube) {
            return 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        }
        else if (videoType === VideoType.vimeo) {
            return 'fullscreen;';
        }
        else if (videoType === VideoType.vimeoShowcase) {
            return 'fullscreen;';
        }
        return '';
    };
    const videoUrl = getVideoUrl();
    const allowAttribute = getAllowAttribute();
    const showCookieBanner = !acceptedVideoCookies;
    if (!allowAttribute || !videoUrl) {
        return null;
    }
    const renderTextContent = () => (_jsxs("div", { className: cmsstyles.videobeskrivelse, children: [title && _jsx("h3", { className: classNames(designsystemtypography.title3, cmsstyles.videobeskrivelse__title), children: title }), description && _jsx("p", { className: cmsstyles.videobeskrivelse__description, children: description })] }));
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: classNames(cmsstyles.videospiller, cmsstyles['videospiller--16by9'], className), ref: videospillerRef, tabIndex: -1, children: [showCookieBanner && _jsx(VideoCookieBanner, { title: title || altText, resources: resources, onChange: handleCookieConsentChange }), _jsx("iframe", { src: showCookieBanner ? 'about:blank' : videoUrl, className: cmsstyles.videospiller__iframe, allow: allowAttribute, title: altText || title })] }), showTextContent && renderTextContent(), visualInterpretation && resources?.hearVisualInterpretation && (_jsx("div", { className: classNames(cmsstyles['videospiller--visualInterpretation']), children: _jsxs(Expander, { title: resources.hearVisualInterpretation, noNestedLine: true, children: [_jsx(PortableText, { value: visualInterpretation }), _jsx("p", { children: _jsx("strong", { children: resources?.doneVisualInterpretation }) })] }) }))] }));
};
export default VideoSpiller;
